module.exports = __webpack_public_path__ + "img/devices.ed38bc1a.svg";